export function SetUrlBuild(filters) {
    let {pathname} = window.location;
    let paramCount = 0;
    let paramsStr = ''

    for(let key in filters) {
        if(!filters[key] || filters[key] === null || filters[key] === '') {
            continue;
        }
        if(paramCount === 0) {
            paramsStr = '?' + key + '=' + filters[key]
        }
        else{
            paramsStr += '&' + key + '=' + filters[key]
        }
        paramCount++;
    }

    window.history.pushState(null, null, pathname + paramsStr);
}

export function ParseUrl(CallBack) {
    const params = new URLSearchParams(window.location.search.substring(1));

    const q = params.get('q') || '';
    const latitude = params.get('latitude') || null;
    const longitude = params.get('longitude') || null;
    const order_date_at = params.get('order_date_at') || '';//''
    const radius = params.get('radius') || null;
    const order_by = params.get('order_by') || null;//''
    const orderposition = params.get('orderposition__order_method_type_id') || null;

    CallBack(q, latitude, longitude, order_date_at, radius, order_by, orderposition);
}



// WEBPACK FOOTER //
// ./src/components/Commons/SetUrlBuild.js